import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { Dialog } from 'primeng/dialog';
import { Button } from 'primeng/button';
import { PrimengButtonDirective, SpinnerFilledComponent } from '@web/shared/ui';
import { Nillable } from '@web/utils';
import { AdminBoxSaleApproveStatus } from '../../models/admin-box-sale-approve-status';

@Component({
  selector: 'app-admin-box-sale-approve-modal',
  imports: [Button, Dialog, PrimengButtonDirective, SpinnerFilledComponent],
  templateUrl: './admin-box-sale-approve-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminBoxSaleApproveModalComponent {
  public readonly isLoading = input(false);
  public readonly isSubmitting = input(false);
  public readonly status = input<Nillable<AdminBoxSaleApproveStatus>>(null);
  public readonly visible = input(false);
  public readonly cancelEvent = output<void>();
  public readonly confirmEvent = output<void>();

  protected handleVisibleChange(visible: boolean): void {
    if (!visible && !this.isSubmitting()) {
      this.cancelEvent.emit();
    }
  }
}
